'use client'
// app/providers.js
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

import {
    QueryClient,
    QueryClientProvider,
    isServer,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import * as React from 'react'
import { ReactQueryStreamedHydration } from '@tanstack/react-query-next-experimental'
import { getQueryClient } from './get-query-client'
import { MainProvider } from '@/context/MainContext'

if (typeof window !== 'undefined') {
    const isLocalhost = window.location.hostname === 'localhost';
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
        ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST as string,
        api_host: process.env.NEXT_PUBLIC_CLOUDFRONT_URL as string,
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    })
}

export function Providers(props: { children: React.ReactNode }) {
    const queryClient = getQueryClient()

    return (
        <QueryClientProvider client={queryClient}>
            <MainProvider>
                <PostHogProvider client={posthog}>
                    <ReactQueryStreamedHydration>
                        {props.children}
                    </ReactQueryStreamedHydration>
                    <ReactQueryDevtools initialIsOpen={false} />
                </PostHogProvider>
            </MainProvider>
        </QueryClientProvider>
    )
}
